export default "__VITE_ASSET__V7rKsR4X__"